/**
 * @generated SignedSource<<c575e83d7ecf2eb0f38afd287cb6ceea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endpointId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "endpointId"
      }
    ],
    "concreteType": "Endpoint",
    "kind": "LinkedField",
    "name": "endpointById",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "price",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nameUk",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "servicePageOrderItemQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "servicePageOrderItemQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d71e9c1432636645c3fc7c2ef9b9112c",
    "id": null,
    "metadata": {},
    "name": "servicePageOrderItemQuery",
    "operationKind": "query",
    "text": "query servicePageOrderItemQuery(\n  $endpointId: String\n) {\n  endpointById(id: $endpointId) {\n    id\n    name\n    price\n    nameUk\n  }\n}\n"
  }
};
})();

node.hash = "8c30aab6fa357df44536f766279b1c81";

module.exports = node;
